import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CommonModule} from '@angular/common';

const routes: Routes = [
  {
    path: 'media',
    loadChildren: () =>
      import(
        './modules/dynamic-media-page-routing/dynamic-media-page-routing-module'
        ).then((m) => m.DynamicMediaPageRoutingModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes),CommonModule],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
